import { render } from "./CommentModal.vue?vue&type=template&id=2fe9452a&scoped=true"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"

import "./CommentModal.vue?vue&type=style&index=0&id=2fe9452a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe9452a"]])

export default __exports__